import { cached } from '@porotutu/react'
import { listQueryOf } from '@porotutu/react/paging'
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { permittedRoute, signedInRoute } from '@/router/root'
import { CAMPAIGN_TYPES, CRM_CAMPAIGN_SORTABLE } from '../vocabulary'
import { ACTIVITY, campaignQuery, campaignsQuery } from './queries'

const campaignSearch = (raw: Record<string, unknown>) =>
  listQueryOf(raw, CRM_CAMPAIGN_SORTABLE, [], [], {
    campaign_type: CAMPAIGN_TYPES,
    active: ACTIVITY,
  })

export const campaignsRoute = createRoute({
  getParentRoute: () => signedInRoute,
  beforeLoad: permittedRoute('campaigns'),
  path: '/campaigns',
  validateSearch: campaignSearch,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => context.queryClient.query(cached(campaignsQuery(deps))),
  component: lazyRouteComponent(() => import('./pages'), 'CampaignsPage'),
})

export const campaignRoute = createRoute({
  getParentRoute: () => signedInRoute,
  beforeLoad: permittedRoute('campaigns'),
  path: '/campaigns/$id',
  validateSearch: campaignSearch,
  loader: ({ context, params }) => context.queryClient.query(cached(campaignQuery(params.id))),
  component: lazyRouteComponent(() => import('./pages'), 'CampaignPage'),
})

export const campaignRoutes = [campaignsRoute, campaignRoute]
